export default __webpack_public_path__ + "static/media/cyl3dflower.29a8ac02.jpg";